import React, { Fragment, useState } from "react"
import { FaPlus } from "react-icons/fa"

import { Tooltip } from "components"
import { thousandSeparator } from "utils"
import SpwTopupModal from "./SpwTopupModal"
import classes from "./index.module.scss"

const SpWallet = (props) => {
  const { serviceOwnerWallet } = props

  const [openTopupModal, setOpenTopupModal] = useState(false)

  return (
    <Fragment>
      <div className={classes["wallet"]}>
        <span className={classes["balance"]}>
          کیف پول من: {thousandSeparator(serviceOwnerWallet.balance)}
        </span>
        <Tooltip
          title="افزایش اعتبار"
        >
          <button
            className={classes["button"]}
            onClick={() => setOpenTopupModal(true)}
          >
            <FaPlus size={14} />
          </button>
        </Tooltip>
      </div>

      <SpwTopupModal
        openTopupModal={openTopupModal}
        setOpenTopupModal={setOpenTopupModal}
      />
    </Fragment>
  )
}

export default SpWallet